/**
 * Suspense fallback for lazily-loaded route pages.
 *
 * Deliberately dependency-free (no icons, no store, no API) so it lives in the
 * entry chunk and can paint instantly on a low-end lab PC. Visually matches the
 * loading state in ProtectedRoute.
 */
export default function RouteFallback() {
    return (
        <div className="min-h-screen flex items-center justify-center bg-slate-50 dark:bg-slate-900">
            <div className="flex flex-col items-center gap-4">
                <div className="w-12 h-12 border-4 border-primary-200 border-t-primary-500 rounded-full animate-spin" />
                <p className="text-slate-500">Loading...</p>
            </div>
        </div>
    );
}
